module.exports = __webpack_public_path__ + "img/racecourse-greyville-poly-1100.a319b0a1.svg";